import { render, staticRenderFns } from "./EmptySummaryList.vue?vue&type=template&id=10405edf&scoped=true&"
import script from "./EmptySummaryList.vue?vue&type=script&lang=js&"
export * from "./EmptySummaryList.vue?vue&type=script&lang=js&"
import style0 from "./EmptySummaryList.vue?vue&type=style&index=0&id=10405edf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10405edf",
  null
  
)

export default component.exports